import React, {useRef} from 'react';
import {formatPackageDurationLabel} from '../CellcomAbroadLobbyBlock/cellcomAbroadUtilities';

export const PackageTerms = ({selectedPackage, sectionRef}) => {
  return (
    <div className='section' ref={(el) => (sectionRef.current[0] = el)} id='section-0'>
      <div className='mainTitle'>
        <h1>
          {'1'}. עיקרי חבילת "{selectedPackage.socDescription}"
        </h1>
      </div>
      <div className='titleAndDescription'>
        <li className='title'>תשלום בגין החבילה(קו בודד)</li>
        <li className='description'> תשלום חד פעמי של {selectedPackage.price} ₪</li>
      </div>
      <div className='titleAndDescription'>
        <li className='title'>תכולת החבילה לקו {window.Config.brand_Name_HE} בודד (ליעדי החבילה ולתקופת החבילה) </li>
        {selectedPackage.packageDetailsList[0]?.voice?.value ? (
          <li className='description listed'>
            עד {selectedPackage.packageDetailsList[0]?.voice?.value} דקות שיחה נכנסת או יוצאת למספר ישראלי (לא כולל שיחות וידאו .)
          </li>
        ) : null}
        {selectedPackage.packageDetailsList[0]?.sms?.value ? (
          <li className='description listed'>
            עד {selectedPackage.packageDetailsList[0]?.sms?.value} הודעות SMS יוצאות למספרים ישראליים (לא כולל הודעות MMS או קבלת SMS )
          </li>
        ) : null}

        {selectedPackage.packageDetailsList[0]?.data?.isUnlimited ? (
          <li className='description listed'>is Unlimited</li>
        ) : selectedPackage.packageDetailsList[0]?.data?.value ? (
          <li className='description listed'>חבילת גלישה בנפח עד GB{selectedPackage.packageDetailsList[0].data.value}</li>
        ) : null}
        {selectedPackage.importantInfo.map((i) => (
          <li className='description listed'>{i}</li>
        ))}
      </div>
      <div className='titleAndDescription'>
        <li className='title'>תקופת החבילה</li>
        <li className='description'>
          {' '}
          החבילה ניתנת למימוש למשך{' '}
          {formatPackageDurationLabel(selectedPackage.packageDuration, selectedPackage.packageDurationUnit)} ממועד תחילת תוקפה.
        </li>
        <li className='description'>
          באפשרותך להגדיר כי החבילה תותקן באופן אוטומטי לכל מנוייך או לחלקם. ככל ובחרת כי, החבילה תותקן באופן אוטומטי, בכל נחיתה באחד מיעדי
          החבילה, המנוי יהנה מתנאי החבילה ויתבצע חיוב בגין החבילה כמפורט בטבלה. לתשומת לבך, החבילה תיכנס לתוקף עבור המנוי עם הנחיתה באחד
          מיעדי החבילה, וזאת אף אם לא בוצע כל שימוש, או במקרה של שהות קצרה ביעד. באפשרותך לבקש לבטל את ההתקנה האוטומטית בכל עת
        </li>
      </div>

      <div className='titleAndDescription'>
        <li className='title'> יעדי החבילה</li>
        <div className='description'>
          <div className='infoRowDescription'>
            <p>
              <span style={{color: 'black'}}>היעדים הבאים בלבד </span>
              (ואינו חל בכל מקרה בשימוש באוניות ובמטוסים): <span> </span>
              {selectedPackage.countrySupportedList.map((country, i, arr) =>
                arr.length - 1 === i ? country.countryHebName + '. ' : country.countryHebName + ', '
              )}{' '}
              (להלן: 'יעדי החבילה').
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
